import { render, staticRenderFns } from "./FakeOrders.vue?vue&type=template&id=ebf06d3e&scoped=true&"
import script from "./FakeOrders.vue?vue&type=script&lang=js&"
export * from "./FakeOrders.vue?vue&type=script&lang=js&"
import style0 from "./FakeOrders.vue?vue&type=style&index=0&id=ebf06d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf06d3e",
  null
  
)

export default component.exports